import { z } from 'zod';
// ============================================================
// Watermark (시안 미리보기 워터마크) Schemas
// ============================================================
// 미활성(미구매) 청첩장·감사장 뷰어에 뜨는 "워터마크 제거" 안내 오버레이의
// 버튼 문구·링크를 admin에서 청첩장/감사장 각각 편집한다.
// 표시 여부 자체는 activated 필드로 결정(여기선 문구·링크만 관리).
export const WatermarkTargetSchema = z.object({
    buttonText: z
        .string()
        .min(1, '버튼 문구를 입력해주세요')
        .max(40, '버튼 문구는 40자를 초과할 수 없습니다'),
    linkUrl: z
        .string()
        .url('올바른 URL을 입력해주세요')
        .refine((u) => /^https?:\/\//i.test(u), 'http/https URL만 허용됩니다'),
});
export const WatermarkConfigSchema = z.object({
    invitation: WatermarkTargetSchema,
    thankyou: WatermarkTargetSchema,
});
// 기본값 — admin 미입력 시 폴백.
const DEFAULT_REMOVE_BUTTON = '워터마크 제거하러가기';
const DEFAULT_PURCHASE_URL = 'https://wedding.fiket.ai/purchase';
export const DEFAULT_WATERMARK_CONFIG = {
    invitation: { buttonText: DEFAULT_REMOVE_BUTTON, linkUrl: DEFAULT_PURCHASE_URL },
    thankyou: { buttonText: DEFAULT_REMOVE_BUTTON, linkUrl: DEFAULT_PURCHASE_URL },
};
//# sourceMappingURL=watermark.js.map